// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32Gpj","colBig":"styles_colBig__2z9bW","colSmall":"styles_colSmall__ggnRl"};